module.exports = __webpack_public_path__ + "static/img/uploadIcon.3fbd504c.svg";